import Security from './lockScreen.ui';

export default Security;
